import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { catalogueApi } from '../services/api';
import { CatalogueShell, Spinner } from '../components/catalogue/CatalogueShell';
import { CategoryTiles } from '../components/catalogue/CategoryTiles';

export default function LightingOverviewPage() {
  const { brandId } = useParams();
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    catalogueApi.overview(brandId).then((r) => setOverview(r.data));
  }, [brandId]);

  return (
    <CatalogueShell
      brandId={brandId}
      crumbs={[{ label: 'Lighting' }]}
      title="Lighting"
      intro={overview ? `${overview.total} products across ${overview.categories.length} categories and ${overview.familyCount} families.` : ''}
      testId="lighting-overview-page"
    >
      {overview ? <CategoryTiles brandId={brandId} overview={overview} /> : <Spinner />}
    </CatalogueShell>
  );
}
